import { render, staticRenderFns } from "./aestheticTherapistPage.vue?vue&type=template&id=1351c84c&scoped=true&"
import script from "./aestheticTherapistPage.vue?vue&type=script&lang=js&"
export * from "./aestheticTherapistPage.vue?vue&type=script&lang=js&"
import style0 from "./aestheticTherapistPage.vue?vue&type=style&index=0&id=1351c84c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1351c84c",
  null
  
)

export default component.exports